import { useEffect, useState } from "react";
import { Analytics } from "@vercel/analytics/react";
import { fetchChampionMastery, fetchRecentlyPlayedGames } from "./apiService";
import {
  CHAMPION_MAP,
  ChampionMastery,
  SteamGame,
  formatMasteryPoints,
  formatPlaytime,
} from "./utils";

function App() {
  //steam
  const [games, setGames] = useState<SteamGame[]>([]);
  const [loadingSteam, setLoadingSteam] = useState<boolean>(true);
  const [errorSteam, setErrorSteam] = useState<string | null>(null);

  //riot
  const [championMastery, setChampionMastery] = useState<ChampionMastery[]>([]);
  const [loadingRiot, setLoadingRiot] = useState<boolean>(true);
  const [errorRiot, setErrorRiot] = useState<string | null>(null);

  useEffect(() => {
    const loadGames = async () => {
      try {
        const recentGames = await fetchRecentlyPlayedGames();
        setGames(recentGames);
      } catch (err) {
        setErrorSteam(
          // hide err for security, but log it to console for debugging
          err instanceof Error ? "Could not fetch Steam info." : ""
        );
      } finally {
        setLoadingSteam(false);
      }
    };

    const loadMastery = async () => {
      try {
        const championMastery = await fetchChampionMastery();
        setChampionMastery(championMastery);
      } catch (err) {
        setErrorRiot(
          err instanceof Error ? err.message : "Could not fetch Riot info."
        );
      } finally {
        setLoadingRiot(false);
      }
    };

    loadGames();
    loadMastery();
  }, []);

  return (
    <div className="App">
      <Analytics />
      <p>a minimal depiction of who i am and what i like</p>
      {/* */}
      <dt>music</dt>
      <ul>
        <li>
          <a href="https://open.spotify.com/user/317o54dlzkjt5cmqvk2bdwz4o2rq?si=be2a0b90cfbe41f5">
            spotify
          </a>
        </li>
        <li>
          <a
            href="https://on.soundcloud.com/RbqppwcGJpxjnZcf8"
            target="_blank"
            rel="noopener noreferrer"
          >
            soundcloud (mainly edm, remixes, hardstyle)
          </a>
        </li>
      </ul>
      {/* */}
      <dt>career - software engineer</dt>
      <ul>
        <li>
          <a
            href="https://drive.google.com/file/d/1GW2BV4fjsQt73fEvsutyc8cbxcmGEz3G/view?usp=sharing"
            target="_blank"
            rel="noopener noreferrer"
          >
            resume
          </a>
        </li>
        <li>
          <a
            href="https://linkedin.com/in/edweenli/"
            target="_blank"
            rel="noopener noreferrer"
          >
            linkedin
          </a>
        </li>
        <li>
          <a
            href="https://github.com/edwinliiiii"
            target="_blank"
            rel="noopener noreferrer"
          >
            github
          </a>
        </li>
      </ul>
      {/* */}
      <dt>dining</dt>
      <ul>
        <li>
          <a
            href="https://beliapp.co/app/eatpoop"
            target="_blank"
            rel="noopener noreferrer"
          >
            my beli
          </a>
        </li>
        <li>
          <a
            href="https://mahaniyomboston.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            mahaniyom - favorite thai food in boston
          </a>
        </li>
        <li>
          <a
            href="https://www.rodthaifenway.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            rod thai - close runner up in boston
          </a>
        </li>
        <li>
          <a
            href="https://maps.app.goo.gl/bWW9u5bmHVexzdU79"
            target="_blank"
            rel="noopener noreferrer"
          >
            hartland diner - the best breakfast i've ever had in the united
            states. was a desperate stop for food during a road trip, turned out
            to be the best decision ever
          </a>
        </li>
      </ul>
      {/* */}
      <dt>cooking</dt>
      <ul>
        <li>
          <a
            href="https://tastecooking.com/recipes/moms-shanghai-red-braised-pork-belly/"
            target="_blank"
            rel="noopener noreferrer"
          >
            my motha's red-braised pork belly
          </a>
        </li>
        <li>
          <a
            href="https://www.justataste.com/greek-yogurt-banana-bread-recipe/"
            target="_blank"
            rel="noopener noreferrer"
          >
            moist greek yogurt banana bread
          </a>
        </li>
        <li>
          <a
            href="https://thewoksoflife.com/katsudon/"
            target="_blank"
            rel="noopener noreferrer"
          >
            egg onion and rice katsudon
          </a>
        </li>
        <li>
          <a
            href="https://thewoksoflife.com/pad-kra-pao/"
            target="_blank"
            rel="noopener noreferrer"
          >
            pad kra pao
          </a>
        </li>
        <li> chicken and broccoli for survival </li>
      </ul>
      {/* */}
      <dt>skating - PA suburbs & Boston</dt>
      <ul>
        <li>
          <a
            href="https://retrospec.com/collections/longboards/products/zed-44-inch-longboard"
            target="_blank"
            rel="noopener noreferrer"
          >
            retrospec zed 44 - my first ever board, sits a bit high and heavy,
            but all-around solid for cruising, 7/10
          </a>
        </li>
        <li>
          <a
            href="https://www.exwayboard.com/products/exway-flex"
            target="_blank"
            rel="noopener noreferrer"
          >
            exway flex 38 - electric skateboard i rode in high school, managing
            truck tightness for carving vs. speed was tough, but great for human
            centipede LMAO, 9/10
          </a>
        </li>
        <li>
          <a
            href="https://www.pennyskateboards.com/collections/22-skateboards/products/blackout-22"
            target="_blank"
            rel="noopener noreferrer"
          >
            pennyboard 22 - small, responsive, zippy board lent to me in
            college, great for carves and turns, not so much speed 7.5/10
          </a>
        </li>
        <li>
          <a
            href="https://landyachtz.com/shop/all/skate/boards/longboards/dipper-watercolor/"
            target="_blank"
            rel="noopener noreferrer"
          >
            landyachtz dipper 36 - my main board summer 2023, carvy and easy
            ride, 8/10
          </a>
        </li>
        <li>
          <a
            href="https://landyachtz.com/shop/discontinued/drop-cat-38-dune-2/"
            target="_blank"
            rel="noopener noreferrer"
          >
            landyachtz drop cat 38 - my current board of choice, great control
            for carving around the city, my first hammer shape though, 9.5/10
          </a>
        </li>
      </ul>
      {/* */}
      <dt>gaming - achievements</dt>
      <ul>
        <li>
          <a
            href="https://hearthstone.blizzard.com/en-us"
            target="_blank"
            rel="noopener noreferrer"
          >
            hearthstone - peaked rank 1
          </a>
        </li>
        <li>
          <a
            href="https://store.steampowered.com/app/553310/Lethal_League_Blaze/"
            target="_blank"
            rel="noopener noreferrer"
          >
            lethal league blaze - peaked top 100
          </a>
        </li>
        <li>
          <a
            href="https://www.leagueoflegends.com/en-us/"
            target="_blank"
            rel="noopener noreferrer"
          >
            league - plat
          </a>
        </li>
        <li>
          <a
            href="https://teamfighttactics.leagueoflegends.com/en-us/"
            target="_blank"
            rel="noopener noreferrer"
          >
            tft - emerald
          </a>
        </li>
        <li>
          <a
            href="https://playvalorant.com/en-us/"
            target="_blank"
            rel="noopener noreferrer"
          >
            valorant - plat
          </a>
        </li>
      </ul>
      {/* */}
      <dt>gaming - recent activity via steam api</dt>
      {loadingSteam ? (
        <p>Loading my Steam games...</p>
      ) : errorSteam ? (
        <p>Error loading Steam data: {errorSteam}</p>
      ) : (
        <ul>
          {games.map((game) => (
            <li key={game.appid}>
              <a
                href={`https://store.steampowered.com/app/${game.appid}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {game.name} - {`${formatPlaytime(game.playtime_forever)} total`}
                {game.playtime_2weeks &&
                  ` (${formatPlaytime(game.playtime_2weeks)} in last 2 weeks)`}
              </a>
            </li>
          ))}
        </ul>
      )}
      <dt>gaming - most played league champions via riot api</dt>
      {loadingRiot ? (
        <p>Loading my Riot data...</p>
      ) : errorRiot ? (
        <p>Error loading champion mastery data: {errorRiot}</p>
      ) : (
        <ul>
          {championMastery.map((champ) => (
            <li key={champ.championId}>
              {CHAMPION_MAP[champ.championId]},{" "}
              {formatMasteryPoints(champ.championPoints)} points
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default App;
